
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

// Definición de defaults

export const defaultFechaAudiencia : FechaAudienciaProps = {
    idSecretario: 0,
    idTipoAudiencia: 0,
    duracion: 0,
    tipoAudiencia: '',
    sala: '',
}

export const defaultSolicitarFechaAudiencia : SolicitarFechaAudienciaProps = {
    idSecretario: 0,
    sala: '',
}

export const defaultSolicitarFechaAudienciaResponse : SolicitarFechaAudienciaResponse = {
    ...defaultHttpResponse,
    ...defaultSolicitarFechaAudiencia,
}

export const defaultAgendaProgramada : AudienciaProgramadaProps = { 
    id: 0, 
    idJuez: 0, 
    juez: '',
    idSecretario: 0, 
    secretario: '',
    sala: '',
    tipoAudiencia: ''
}

// Creación de interfaces

export interface SolicitarFechaAudienciaParams {
    idAcuerdo:          number;
    idAudiencia:        number;
    idTipoAudiencia:    number;
    idTipoAcuerdo:      number;
    idSubTipoAcuerdo:   number;
    duracion:           number;
}

export interface SolicitarFechaAudienciaProps {
    idSecretario:       number;
    sala:               string;
    fechaInicio?:       Date;
    fechaFin?:          Date;
}

export interface FechaAudienciaProps {
    idSecretario:       number;
    idTipoAudiencia:    number;
    duracion:           number;
    tipoAudiencia:      string;
    sala:               string;
    fechaInicio?:       Date;
    fechaFin?:          Date;
}

export interface SolicitarFechaAudienciaResponse extends HttpResponse, SolicitarFechaAudienciaProps {}

export interface AudienciaProgramadaProps{
    id:             number;
    tipoAudiencia:  string;
    idJuez:         number;
    juez:           string;
    idSecretario:   number;
    secretario:     string;
    sala:           string;
    fechaInicio?:   Date;
    fechaFin?:      Date;
}

export interface CancelarFechaAudienciaParams {
    idAgenda:               number;
    motivoCancelacion:      string;
}